var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"lt-scene_shelf"},[_c('SceneItemTransition',{attrs:{"isActive":_vm.holiday === 3}},[_c('img',{staticClass:"lt-scene_cupboard_holiday",attrs:{"src":require("../../assets/holiday-3.svg"),"alt":""}})])],1)}
var staticRenderFns = []

export { render, staticRenderFns }